module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 3rem 0"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "value": _vm.formData.saiqu.name,
      "title": "赛区"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "value": _vm.formData.baoming.danwei,
      "title": "单位"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "value": _vm.formData.baoming.mingcheng,
      "title": "队伍名称"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "value": _vm.formData.subject_name,
      "title": "项目"
    }
  }), _vm._v(" "), (_vm.canSubmit) ? _c('van-cell', {
    attrs: {
      "title": "上传照片",
      "value": _vm.formData.pic.length + '/1'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canSubmit) ? _c('div', {
    staticClass: "row"
  }, [_c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.pic,
      "limit": 1,
      "name": 'pic'
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.canSubmit) ? _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("请上传一张照片")]) : _vm._e(), _vm._v(" "), (_vm.canSubmit) ? _c('van-cell', {
    attrs: {
      "title": "视频",
      "value": _vm.formData.pic.length + '/1'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canSubmit) ? _c('div', {
    staticClass: "row"
  }, [_c('VideoUploader', {
    attrs: {
      "minSize": 0,
      "fileList": _vm.formData.video,
      "limit": 1,
      "fileName": _vm.formData.baoming.mingcheng + '-' + _vm.formData.subject_name,
      "name": 'video'
    },
    on: {
      "onInputClick": _vm.onVideoInputClick
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.canSubmit) ? _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("请上传一段视频")]) : _vm._e()], 1), _vm._v(" "), (_vm.canSubmit) ? _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交")])], 1) : _vm._e()], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29786134","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/isai/SaiApplyFormUploadVideo.vue
// module id = 1179
// module chunks = 0